import { FC } from "react";
import { EditPersonalInfoFormPage } from "./edit-personal-info.form.page";
import useSWR from "swr";
import { useUsersDomain } from "src/domain/users/users.domain";

const EditPersonalInfoPage: FC = () => {
  const { getUser } = useUsersDomain();
  const { data: userData, mutate } = useSWR("getUser", getUser);

  if (!userData) return <></>;

  return (
    <div style={{ maxWidth: "400px" }}>
      <EditPersonalInfoFormPage
        defaultValues={userData}
        onSubmit={() => mutate()}
      />
    </div>
  );
};
export default EditPersonalInfoPage;
